module.exports = __webpack_public_path__ + "img/iPhone-jobs.e2598fe1.webp";